import React, { useEffect, useState } from "react";
import Form, {
  SimpleItem, GroupItem, Label, RequiredRule, ButtonItem, ButtonOptions, TabbedItem, TabPanelOptions, Tab
} from 'devextreme-react/form';
import { LVForm } from "../Basicos/LVForm";
import ComboAbmZonPlantas from "../Compuestos/Combos/ComboAbmZonPlantas";
import ComboAbmZonEmpresas from "../Compuestos/Combos/ComboAbmZonEmpresas";
import LVButtonAccion from "../Basicos/LVButtonAccion";
import { LVGridCarga } from "../Basicos/LVGridCarga";
import { Column } from "devextreme-react/data-grid";
import LV_EEX_ClientesLocaciones from "../Compuestos/Complejos/Clientes/LV_EEX_ClientesLocaciones";
import LV_EEX_ClientesPersonasRelevantes from "../Compuestos/Complejos/Clientes/LV_EEX_ClientesPersonasRelevantes";
import { function_VEN_ABM_EEX_ClientesPersonasRelevantes_Eliminar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_ClientesPersonasRelevantes";
import { function_VEN_ABM_EEX_ClientesLocaciones_Eliminar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_ClientesLocaciones";
import { function_ABM_EEX_ClientesSocios_Generar_JSON, function_ABM_EEX_ClientesSocios_Insertar, function_ABM_EEX_ClientesSocios_Leer, function_ABM_EEX_ClientesSocios_Modificar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_ClientesSocios";

const ABM_EEX_ClientesSocios = (props) => {
  const [datos, setDatos] = useState([]);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [esModificacion, setEsModificacion] = useState(false);
  const [esMultiEmpresa, setEsMultiEmpresa] = useState(true);
  const [esMultiPlanta, setEsMultiPlanta] = useState(true);
  const [plantaSeleccionada, setPlantaSeleccionada] = useState(null);
  const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);

  const handleOnValueChangedMultiEmpresa = (e) => {
    const isChecked = e.value;

    setEsMultiEmpresa(isChecked)
    setDatos((prevDatos) => ({
      ...prevDatos,
      MultiEmpresa: isChecked
    }));
  };

  const handleOnValueChangedMultiPlanta = (e) => {
    const isChecked = e.value;

    setEsMultiPlanta(isChecked)
    setDatos((prevDatos) => ({
      ...prevDatos,
      MultiPlanta: isChecked
    }));
  };

  const handleOnClick_AgregarPlanta = async (e) => {
    if (!plantaSeleccionada.codigo) {
      alert("Seleccione una Planta antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const plantaYaExiste = datos.ListPlantas?.some(
      (planta) => planta.ABM_ZON_Plantas_CodigoPlanta === plantaSeleccionada.codigo
    );

    if (plantaYaExiste) {
      alert("La Planta ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto
    const nuevaPlanta = {
      ABM_ZON_Plantas_CodigoPlanta: plantaSeleccionada.codigo,
      CodigoPlanta: plantaSeleccionada.codigo,
      Descripcion: plantaSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListPlantas: [...(prevDatos.ListPlantas || []), nuevaPlanta],
    }));

    // Limpiar la selección después de agregar
    setPlantaSeleccionada(null);
  }

  const handleOnClick_AgregarEmpresa = async (e) => {
    if (!empresaSeleccionada.codigo) {
      alert("Seleccione una Empresa antes de agregar.");
      return;
    }

    // Verificar si ya está en la lista
    const empresaYaExiste = datos.ListEmpresas?.some(
      (empresa) => empresa.ABM_ZON_Empresas_CodigoEmpresa === empresaSeleccionada.codigo
    );

    if (empresaYaExiste) {
      alert("La Empresa ya ha sido agregada.");
      return;
    }

    // Crear el nuevo objeto
    const nuevaEmpresa = {
      ABM_ZON_Empresas_CodigoEmpresa: empresaSeleccionada.codigo,
      CodigoEmpresa: empresaSeleccionada.codigo,
      Descripcion: empresaSeleccionada.descripcion,
      CodigoCompania: localStorage.getItem("CodigoCompania"),
      ABM_ART_Articulos_CodigoArticulo: ""
    };

    // Agregar el nuevo item a la coleccion
    setDatos((prevDatos) => ({
      ...prevDatos,
      ListEmpresas: [...(prevDatos.ListEmpresas || []), nuevaEmpresa],
    }));

    // Limpiar la selección después de agregar
    setEmpresaSeleccionada(null);
  }

  const handleOnClick_Guardar = async (e) => {
    try {

      if (!datos.RazonSocial || datos.RazonSocial.trim() === "") {
        datos.RazonSocial = `${datos.Nombre || ""} ${datos.Apellido || ""}`.trim();
      }

      const JSON = await function_ABM_EEX_ClientesSocios_Generar_JSON(
        datos.IdCliente,
        datos.MultiPlanta,
        datos.MultiEmpresa,
        datos.RazonSocial,
        datos.Apellido,
        datos.Nombre,
        datos.CUIT,
        5,
        'CC1',
        datos.Observaciones,
        11,
        1,
        null,
        null,
        datos.Categoria,
        datos.HuellaDactilar,
        datos.HuellaDactilarString,
        datos.LimiteCreditoAviso,
        datos.LimiteCreditoCorte,
        datos.NombreFantasia,
        datos.PuntosAcumulados,
        datos.OpAutGenera,
        datos.OpAutIdProveedor,
        datos.OpAutIdTipoDocCompra,
        datos.OpAutCodigoSubCC,
        datos.OpAutCodigoCuentaFinanciera,
        datos.OpAutCodigoPlantaCompra,
        datos.SubidoEnNube,
        datos.Agrupador,
        datos.ListPlantas,
        datos.ListEmpresas,
        datos.Sexo,
        datos.ObraSocial,
        datos.NroObraSocial,
        datos.Plantel,
        datos.Division,
        datos.AlergiasMedicamentos,
        datos.AlergiasObjetos,
        datos.GrupoSanguineo,
        datos.Federada,
        datos.AptoFisico,
        datos.NumeroDeJugador,
        datos.Profesion
      )

      if (props.Codigo.Codigo === "--NUEVO--") {

        const Creado = await function_ABM_EEX_ClientesSocios_Insertar(JSON, false)

        alert("Se ha generado el Código: " + Creado.data.codigoGenerado)
      } else {

        const Modificado = await function_ABM_EEX_ClientesSocios_Modificar(JSON, false)

        alert("Se ha modificado el Código: " + datos.IdCliente)
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    }
  }

  useEffect(() => {

    const getData = async () => {
      try {
        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")

          setDatos({
            IdCliente: 0,
            MultiPlanta: true,
            MultiEmpresa: true,
            RazonSocial: '',
            Apellido: '',
            Nombre: '',
            CUIT: '',
            IdTipoIVA: 0,
            CodigoCuentaContableDefault: '',
            Observaciones: '',
            IdTipoDocVentaDefault: 0,
            IdProfesionalVendedorAsignado: 0,
            CodigoCondicionVenta: '',
            CodigoListaPrecios: '',
            Categoria: '',
            HuellaDactilar: '',
            HuellaDactilarString: '',
            LimiteCreditoAviso: 0,
            LimiteCreditoCorte: 0,
            NombreFantasia: '',
            PuntosAcumulados: 0,
            OpAutGenera: false,
            OpAutIdProveedor: 0,
            OpAutIdTipoDocCompra: 0,
            OpAutCodigoSubCC: '',
            OpAutCodigoCuentaFinanciera: '',
            OpAutCodigoPlantaCompra: '',
            SubidoEnNube: false,
            Agrupador: '',
            Sexo: '',
            ObraSocial: '',
            NroObraSocial: '',
            Plantel: '',
            Division: '',
            AlergiasMedicamentos: '',
            AlergiasObjetos: '',
            GrupoSanguineo: '',
            Federada: '',
            AptoFisico: '',
            NumeroDeJugador: '',
            Profesion: ''
          })
        } else {
          setTituloBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setAccionBoton("ACTUALIZAR CÓDIGO " + props.Codigo.Codigo)
          setEsModificacion(true)

          const datosDocumento = await function_ABM_EEX_ClientesSocios_Leer(props.Codigo.Codigo)

          setDatos(datosDocumento.data)

          setEsMultiPlanta(datosDocumento.data.MultiPlanta)
          setEsMultiEmpresa(datosDocumento.data.MultiEmpresa)
        }
      } catch (error) {
        alert(error);
      }
    }
    getData();
  }, []);

  const validateForm = (e) => {
    e.component.validate();
  };

  return (
    <LVForm
      colCount={1}
      formData={datos}
      onContentReady={validateForm}
    >
      <TabbedItem>
        <TabPanelOptions deferRendering={false} />

        <Tab title="General" colCount={3}>
          <GroupItem caption="General">
            <SimpleItem dataField="IdCliente" disabled={true} >
              <Label text="Código" />
            </SimpleItem>
            <SimpleItem dataField="RazonSocial">
              <Label text="Razón Social" />
            </SimpleItem>
            <SimpleItem dataField="Nombre">
              <Label text="Nombre" />
            </SimpleItem>
            <SimpleItem dataField="Apellido">
              <Label text="Apellido" />
            </SimpleItem>
            <SimpleItem dataField="Sexo">
              <Label text="Sexo" />
            </SimpleItem>
            <SimpleItem dataField="CUIT">
              <Label text="D.N.I." />
            </SimpleItem>
            <SimpleItem dataField="Profesion">
              <Label text="Profesión" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Deportivos" colCount={1}>
            <SimpleItem dataField="Plantel">
              <Label text="Plantel" />
            </SimpleItem>
            <SimpleItem dataField="Division">
              <Label text="División" />
            </SimpleItem>
            <SimpleItem dataField="Federada">
              <Label text="Federada" />
            </SimpleItem>
            <SimpleItem dataField="NumeroDeJugador">
              <Label text="Número de Jugador" />
            </SimpleItem>
          </GroupItem>

          <GroupItem caption="Medicina" colCount={1}>
            <SimpleItem dataField="ObraSocial">
              <Label text="Obra Social / Prepaga" />
            </SimpleItem>
            <SimpleItem dataField="NroObraSocial">
              <Label text="Número Obra Social / Prepaga" />
            </SimpleItem>
            <SimpleItem dataField="GrupoSanguineo">
              <Label text="Grupo Sanguineo" />
            </SimpleItem>
            <SimpleItem dataField="AlergiasMedicamentos">
              <Label text="Alergias a Medicamentos" />
            </SimpleItem>
            <SimpleItem dataField="AlergiasObjetos">
              <Label text="Alergias a Objetos" />
            </SimpleItem>
          </GroupItem>
        </Tab>

        <Tab title="Locaciones" visible={esModificacion}>
          <GroupItem>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {datos.Locaciones?.map((loc, index) => (
                <div className="LV-GroupBox-div" key={index} style={{ position: "relative", padding: "10px" }}>
                  <LV_EEX_ClientesLocaciones
                    index={index}
                    datos={datos}
                    setDatos={setDatos}
                  />
                  <button
                    onClick={async () => {
                      const nuevasLocaciones = [...datos.Locaciones];
                      const locAEliminar = nuevasLocaciones[index];

                      if (locAEliminar?.IdCliente && locAEliminar?.CodigoLocacionCliente) {
                        const confirmacion = window.confirm("¿Seguro que querés eliminar esta locación?");
                        if (!confirmacion) return;

                        try {
                          await function_VEN_ABM_EEX_ClientesLocaciones_Eliminar(locAEliminar.IdCliente, locAEliminar.CodigoLocacionCliente);
                          alert("Locación eliminada con éxito del servidor.");
                        } catch (error) {
                          alert("Error al eliminar la locación: " + error.message);
                          return;
                        }
                      }

                      nuevasLocaciones.splice(index, 1);
                      setDatos((prev) => ({
                        ...prev,
                        Locaciones: nuevasLocaciones
                      }));
                    }}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      background: "transparent",
                      border: "none",
                      color: "#900",
                      fontWeight: "bold",
                      fontSize: "18px",
                      cursor: "pointer"
                    }}
                  >
                    ✕
                  </button>
                </div>
              ))}
              <LVButtonAccion
                Texto="AGREGAR LOCACIÓN"
                onClick={() => {
                  const nuevaLocacion = {
                    CodigoLocacionCliente: "",
                    IdTipoLocacion: "",
                    Calle: "",
                    Numero: "",
                    Piso: "",
                    Depto: "",
                    CodigoPostal: "",
                    IdPais: "",
                    Email: "",
                    Telefono: "",
                    TelefonoFax: "",
                    TelefonoCelular: "",
                    HorarioAtencion: "",
                    Responsable1: "",
                    Responsable2: "",
                    Responsable3: "",
                    Observaciones: "",
                    EsDefaultParaRemito: false,
                    IdCiudad: "",
                    DomicilioFacturacion: false,
                    CodigoEmpresaTransporte: "",
                    CodigoLocacionEmpresaTransporte: "",
                    CodigoZona: "",
                    Coordenadas: ""
                  };
                  setDatos((prev) => ({
                    ...prev,
                    Locaciones: [...(prev.Locaciones || []), nuevaLocacion]
                  }));
                }}
              />
            </div>
          </GroupItem>
        </Tab>

        <Tab title="Personas Relevantes" visible={esModificacion}>
          <GroupItem>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {datos.PersonasRelevantes?.map((persona, index) => (
                <div className="LV-GroupBox-div" key={index} style={{ position: "relative", padding: "10px" }}>
                  <LV_EEX_ClientesPersonasRelevantes
                    index={index}
                    datos={datos}
                    setDatos={setDatos}
                  />
                  <button
                    onClick={async () => {
                      const nuevasPersonas = [...datos.PersonasRelevantes];

                      const personaAEliminar = nuevasPersonas[index];

                      if (personaAEliminar?.IdCliente) {
                        const confirmacion = window.confirm("¿Seguro que querés eliminar esta persona?");
                        if (!confirmacion) return;

                        try {
                          await function_VEN_ABM_EEX_ClientesPersonasRelevantes_Eliminar(personaAEliminar.IdCliente, personaAEliminar.Nombre, personaAEliminar.Apellido);
                          alert("Persona eliminada con éxito del servidor.");
                        } catch (error) {
                          alert("Error al eliminar la persona: " + error.message);
                          return;
                        }
                      }

                      nuevasPersonas.splice(index, 1);
                      setDatos((prev) => ({
                        ...prev,
                        PersonasRelevantes: nuevasPersonas
                      }));
                    }}
                    style={{
                      position: "absolute",
                      top: "5px",
                      right: "5px",
                      background: "transparent",
                      border: "none",
                      color: "#900",
                      fontWeight: "bold",
                      fontSize: "18px",
                      cursor: "pointer"
                    }}
                  >
                    ✕
                  </button>
                </div>
              ))
              }
              <LVButtonAccion
                Texto="AGREGAR PERSONA RELEVANTE"
                onClick={() => {
                  const nuevaPersona = {
                    Nombre: "",
                    Apellido: "",
                    Cargo: "",
                    Telefono: "",
                    Email: ""
                  };
                  setDatos((prev) => ({
                    ...prev,
                    PersonasRelevantes: [...(prev.PersonasRelevantes || []), nuevaPersona]
                  }));
                }}
              />
            </div>
          </GroupItem>
        </Tab>

        <Tab title="Plantas">
          <GroupItem>
            <SimpleItem dataField="MultiPlanta" editorType="dxCheckBox"
              editorOptions={{ onValueChanged: (e) => handleOnValueChangedMultiPlanta(e) }}>
              <Label text="MultiPlanta (Desactivado permite definir para que Plantas estará disponible)" />
            </SimpleItem>
          </GroupItem>

          <GroupItem visible={!esMultiPlanta}>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmZonPlantas
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component && typeof e.component.option === "function"
                    ? e.component.option("text")
                    : "";
                  setPlantaSeleccionada({ codigo: e.value, descripcion });
                }} />
              <LVButtonAccion Texto={"AGREGAR PLANTA"} onClick={handleOnClick_AgregarPlanta} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListPlantas}
              keyExpr="ABM_ZON_Plantas_CodigoPlanta"
            >
              <Column caption="Código" dataField="ABM_ZON_Plantas_CodigoPlanta" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>

        <Tab title="Empresas">
          <GroupItem>
            <SimpleItem dataField="MultiEmpresa" editorType="dxCheckBox"
              editorOptions={{ onValueChanged: (e) => handleOnValueChangedMultiEmpresa(e) }}>
              <Label text="MultiEmpresa (Desactivado permite definir para que Empresas estará disponible)" />
            </SimpleItem>
          </GroupItem>

          <GroupItem visible={!esMultiEmpresa}>
            <div className="LV-FlexContainer" style={{ marginBottom: '20px' }}>
              <ComboAbmZonEmpresas
                ancho="500"
                CodigoCompania={localStorage.getItem("CodigoCompania")}
                CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
                CodigoPlanta={localStorage.getItem("CodigoPlanta")}
                onValueChanged={(e) => {
                  const descripcion = e.component && typeof e.component.option === "function"
                    ? e.component.option("text")
                    : "";
                  setEmpresaSeleccionada({ codigo: e.value, descripcion });
                }} />
              <LVButtonAccion Texto={"AGREGAR EMPRESA"} onClick={handleOnClick_AgregarEmpresa} />
            </div>

            <LVGridCarga
              id="gridContainer"
              dataSource={datos.ListEmpresas}
              keyExpr="ABM_ZON_Empresas_CodigoEmpresa"
            >
              <Column caption="Código" dataField="ABM_ZON_Empresas_CodigoEmpresa" width="80" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth="200" alignment="Left" dataType="string" />
            </LVGridCarga>
          </GroupItem>
        </Tab>


      </TabbedItem>

      <ButtonItem horizontalAlignment="Center">
        <ButtonOptions onClick={handleOnClick_Guardar} type='success' useSubmitBehavior={true} text={TituloBoton} />
      </ButtonItem>
    </LVForm>
  );

}

export default ABM_EEX_ClientesSocios;